module.exports = __webpack_public_path__ + "static/fonts/Fact-ExtraBoldItalic.4743f6c.woff";